import { createContext, useState } from "react";
import { User } from "../hooks/useUser";
import React from "react";

interface AuthContext {
  user: User | null;
  setUser: (user: User | null) => void;
  
}

export const AuthContext = createContext<AuthContext>({
  user: null,
  setUser: () => {},
});

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState<User | null>(null);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
